<template>
  <div ref="targetEl">
    <slot v-if="inViewport"></slot>
  </div>
</template>

<script setup>
import { useIntersectionObserver } from '@vueuse/core';
import { ref } from 'vue';

const props = defineProps({
  rootMargin: {
    type: Number,
    default: 600,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const inViewport = ref(props.disabled);
const targetEl = ref(null);

if (!props.disabled) {
  const { stop } = useIntersectionObserver(
    targetEl,
    ([{ isIntersecting }]) => {
      if (isIntersecting) {
        inViewport.value = isIntersecting;
        stop();
      }
    },
    {
      rootMargin: `${props.rootMargin}px`,
    },
  );
}
</script>
